var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWgWellStatusInprogress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#B8E986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7957 7.22118C11.1621 7.51327 11.1739 8.06613 10.8203 8.37362L6.74213 11.9199C6.25671 12.342 5.5 11.9972 5.5 11.3539L5.5 4.55694C5.5 3.92867 6.2262 3.57885 6.71748 3.97046L10.7957 7.22118Z",
    fill: "#071B31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgWellStatusInprogress);
export default __webpack_public_path__ + "static/media/wg-well-status-inprogress.c5b63834116d71fa4f6b0820d2dd5a24.svg";
export { ForwardRef as ReactComponent };